import { mergeClassName as e } from "../../utils/data.js";
import t from "./Calendar.module.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { CheckIcon as i } from "@phosphor-icons/react";
//#region lib/components/DatePicker/PresetsSidebar.tsx
function a({ presets: a, activePresetId: o, onSelect: s, className: c }) {
	return /* @__PURE__ */ n("div", {
		className: e(t.presets, c),
		children: a.map((a) => {
			let c = a.id === o;
			return /* @__PURE__ */ r("button", {
				type: "button",
				className: e(t.presetItem, c && t.presetItemActive),
				onClick: () => {
					s(a);
				},
				children: [/* @__PURE__ */ n("span", { children: a.label }), c && /* @__PURE__ */ n(i, {
					size: 16,
					className: t.presetCheck,
					"aria-hidden": !0
				})]
			}, a.id);
		})
	});
}
//#endregion
export { a as PresetsSidebar };
